<template>
    <div class="nk-app-root">
               
        <div class="nk-main ">
            <div class="nk-sidebar nk-sidebar-fixed " data-content="sidebarMenu">
                <div class="nk-sidebar-element nk-sidebar-head">
                    <div class="nk-sidebar-brand">
                        <a href="javascript:void(0)" class="logo-link nk-sidebar-logo">
                            <img class="logo-light logo-img" src="/images/logo.png" srcset="/images/logo.png 2x" alt="logo" style="max-height:60px;">
                            <img class="logo-dark logo-img" src="/images/logo-dark.png" srcset="/images/logo.png 2x" alt="logo-dark" style="max-height:60px;">
                        </a>
                    </div>
                    <div class="nk-menu-trigger me-n2">
                        <a href="javascript:void(0)" class="nk-nav-toggle nk-quick-nav-icon d-xl-none" data-target="sidebarMenu"><em class="icon ni ni-arrow-left"></em></a>
                    </div>
                </div>
                <div class="nk-sidebar-element">
                    <div class="nk-sidebar-body" data-simplebar>
                        <div class="nk-sidebar-content">
                            <div class="nk-sidebar-widget d-xl-block">
                                <div class="user-account-actions" v-if="role=='Customer'">
                                    <ul class="g-3">
                                        <li v-if="!activeBasicPackage"><a href="/PackagePlan" class="btn btn-lg btn-primary" :disabled="activeBasicPackage"><span>Deposit</span></a></li>
                                        <li><a v-on:click="openModel()" href="javascript:void(0)" class="btn btn-lg btn-warning" v-bind:class="activeBasicPackage? 'btn-block': ''"><span>Withdraw</span></a></li>
                                    </ul>
                                </div>
                                <div class="user-account-actions">
                                    <span class="sub-text">Share Referral Link</span>
                                    <div class="nk-refwg-url">
                                        <div class="form-control-wrap">
                                            <div class="form-clip clipboard-init" data-clipboard-target="#refUrl" data-success="Copied"><em class="clipboard-icon icon ni ni-copy"></em> <span class="clipboard-text"></span></div>
                                            <div class="form-icon">
                                                <em class="icon ni ni-link-alt"></em>
                                            </div>
                                            <input type="text" class="form-control copy-text" id="refUrl" :value="urlLink">
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="nk-sidebar-menu">
                                
                                <ul class="nk-menu" style="margin-bottom:3.8rem;">
                                    <li class="nk-menu-heading">
                                        <h6 class="overline-title">Menu</h6>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/Dashboard" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-dashboard"></em></span>
                                            <span class="nk-menu-text">Dashboard</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Super Admin' || role=='Admin' || role=='Manager'">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/AdminDashboard')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-dashboard"></em></span>
                                            <span class="nk-menu-text">Dashboard</span>
                                        </a>
                                    </li>

                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/PackagePlan" class="nk-menu-link" v-if="!activeBasicPackage">
                                            <span class="nk-menu-icon"><em class="icon ni ni-layers"></em></span>
                                            <span class="nk-menu-text">Package Plan</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/CreateNewId" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-grid-add-fill-c"></em></span>
                                            <span class="nk-menu-text">Create New Id</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/IdHistory" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-list-index"></em></span>
                                            <span class="nk-menu-text">Id History</span>
                                        </a>
                                    </li>


                                    <li class="nk-menu-heading" v-if="role=='Customer'">
                                        <h6 class="overline-title">Cash</h6>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/Withdrawal" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-repeat"></em></span>
                                            <span class="nk-menu-text">Withdraw History</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/MyPackage" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-coins"></em></span>
                                            <span class="nk-menu-text">My Package</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer' && packagePlanAmount > 0 && packagePlanAmount < 100">
                                        <a href="/PackageUpgrade" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-align-justify"></em></span>
                                            <span class="nk-menu-text">Package Upgrade</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/RoiHistory" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-tranx"></em></span>
                                            <span class="nk-menu-text">Roi History</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/UniLevelBonusHistory" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-history"></em></span>
                                            <span class="nk-menu-text">UniLevel History</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/EarningHistory" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-growth-fill"></em></span>
                                            <span class="nk-menu-text">Earning History</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/RewardBonusHistory" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-property"></em></span>
                                            <span class="nk-menu-text">Reward History</span>
                                        </a>
                                    </li>

                                    <li class="nk-menu-heading" v-if="role=='Customer'">
                                        <h6 class="overline-title">Teams</h6>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/MyTeam" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-users"></em></span>
                                            <span class="nk-menu-text">My Team</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Customer'">
                                        <a href="/DirectTeam" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-user-add"></em></span>
                                            <span class="nk-menu-text">Direct Team</span>
                                        </a>
                                    </li>


                                    <li class="nk-menu-heading" v-if="role=='Super Admin' || role=='Admin' || role=='Manager'">
                                        <h6 class="overline-title">Tools</h6>
                                    </li>

                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/BuyPackages')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-file-docs"></em></span>
                                            <span class="nk-menu-text">Packages Request</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/UpgradePackageList')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-view-group-fill"></em></span>
                                            <span class="nk-menu-text">Upgrade Package Request</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Super Admin' || role=='Admin' || role=='Manager'">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/Withdrawal')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-repeat"></em></span>
                                            <span class="nk-menu-text">Withdraw Request</span>
                                        </a>
                                    </li>
                                    <li class="nk-menu-item" v-if="role=='Super Admin' || role=='Admin' || role=='Manager'">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/KycRequest')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-account-setting-fill"></em></span>
                                            <span class="nk-menu-text">KYC Request</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/UniLevelBonus')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-sign-bnb-alt"></em></span>
                                            <span class="nk-menu-text">ROI Bonus</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/BuyNewId')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-view-col3"></em></span>
                                            <span class="nk-menu-text">Create New Id</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/PaymentVouchers')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-view-col3"></em></span>
                                            <span class="nk-menu-text">Reward Bonus</span>
                                        </a>
                                    </li>


                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-heading">
                                        <h6 class="overline-title">Setting</h6>
                                    </li>
                                    <li v-if="role=='Super Admin'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/coa')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-bar-chart"></em></span>
                                            <span class="nk-menu-text">Chart Of Account</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/UserList')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-users"></em></span>
                                            <span class="nk-menu-text">All Customer</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/Bank')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-home-alt"></em></span>
                                            <span class="nk-menu-text">Bank List</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/PackagePrice')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-package-fill"></em></span>
                                            <span class="nk-menu-text">Package List</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/PaymentOptions')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-sign-sgd-alt"></em></span>
                                            <span class="nk-menu-text">Payment Options</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/Currencies')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-sign-dollar"></em></span>
                                            <span class="nk-menu-text">Currencies</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="javascript:void(0)" v-on:click="GoTo('/DailyExpenses')" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-exchange-v"></em></span>
                                            <span class="nk-menu-text">Daily Expense</span>
                                        </a>
                                    </li>


                                    <li class="nk-menu-heading">
                                        <h6 class="overline-title">Support</h6>
                                    </li>

                                    <li class="nk-menu-item">
                                        <a href="/Tickets" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-ticket-plus-fill"></em></span>
                                            <span class="nk-menu-text">Tickets</span>
                                        </a>
                                    </li>
                                    <li v-if="role=='Super Admin' || role=='Admin' || role=='Manager'" class="nk-menu-item">
                                        <a href="/Emails" class="nk-menu-link">
                                            <span class="nk-menu-icon"><em class="icon ni ni-ticket-plus-fill"></em></span>
                                            <span class="nk-menu-text">Emails</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            
            <div class="nk-wrap ">
                
                <div class="nk-header nk-header-fluid nk-header-fixed is-light">
                    <div class="container-fluid">
                        <div class="nk-header-wrap">
                            <div class="nk-menu-trigger d-xl-none ms-n1">
                                <a href="javascript:void(0)" class="nk-nav-toggle nk-quick-nav-icon" data-target="sidebarMenu"><em class="icon ni ni-menu"></em></a>
                            </div>
                            <div class="nk-header-brand d-xl-none">
                                <a href="javascript:void(0)" class="logo-link">
                                    <img class="logo-light logo-img" src="/images/logo.png" alt="logo">
                                    <img class="logo-dark logo-img" src="/images/logo.png" alt="logo-dark">
                                </a>
                            </div>
                            <div class="nk-header-news d-none d-xl-block">
                                <div class="nk-news-list">
                                </div>
                            </div>
                            <div class="nk-header-tools">
                                <ul class="nk-quick-nav">
                                    <li class="dropdown language-dropdown d-none d-sm-block me-n1">
                                        <a href="javascript:void(0)" class="dropdown-toggle nk-quick-nav-icon" data-bs-toggle="dropdown">
                                            <div class="quick-icon border border-light">
                                                <img class="icon" src="/images/flags/english-sq.png" alt="">
                                            </div>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-end dropdown-menu-s1">
                                            <ul class="language-list">
                                                <li v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
                                                    <a href="javascript:void(0)" class="language-item">
                                                        <img v-if="lang=='en'" src="/images/flags/english.png" alt="" class="language-flag">
                                                        <img v-if="lang=='ar'" src="/images/flags/turkey.png" alt="" class="language-flag">
                                                        <span class="language-name">{{ lang.toUpperCase() }}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li class="dropdown user-dropdown">
                                        <a href="javascript:void(0)" class="dropdown-toggle" data-bs-toggle="dropdown">
                                            <div class="user-toggle">
                                                <div class="user-avatar sm">
                                                    <em class="icon ni ni-user-alt"></em>
                                                </div>
                                                <div class="user-info  d-md-block">
                                                    <div v-if="verified" class="user-status user-status-verified">Verified</div>
                                                    <div v-else class="user-status user-status-unverified">Unverified</div>
                                                    <div class="user-name dropdown-indicator">{{ displayUserName }}</div>
                                                </div>
                                            </div>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-md dropdown-menu-end dropdown-menu-s1">
                                            <div class="dropdown-inner user-card-wrap bg-lighter  d-md-block">
                                                <div class="user-card">
                                                    <div class="user-avatar">
                                                        <span>{{shortName}}</span>
                                                    </div>
                                                    <div class="user-info">
                                                        <span class="lead-text">{{ fullName }}</span>
                                                        <span class="sub-text">{{ displayUserEmail }}</span>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="dropdown-inner">
                                                <ul class="link-list">
                                                    <li><a href="/UserProfileInfo"><em class="icon ni ni-user-alt"></em><span>View Profile</span></a></li>
                                                    <li v-if="isImpersonating"><a v-on:click="AdminLogin()" href="javascript:void(0)"><em class="icon ni ni-dashboard"></em><span>Admin Dashboard</span></a></li>
                                                    
                                                </ul>
                                            </div>
                                            <div class="dropdown-inner">
                                                <ul class="link-list">
                                                    <li v-on:click="logout"><a href="javascript:void(0)"><em class="icon ni ni-signout"></em><span>Sign out</span></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="dropdown notification-dropdown me-n1">
                                        <a href="javascript:void(0)" class="dropdown-toggle nk-quick-nav-icon" data-bs-toggle="dropdown">
                                            <div class="icon-status icon-status-info"><em class="icon ni ni-bell"></em></div>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-xl dropdown-menu-end dropdown-menu-s1">
                                            <div class="dropdown-head">
                                                <span class="sub-title nk-dropdown-title">Notifications</span>
                                                <a v-on:click="GetNotificationData()" href="javascript:void(0)">Refresh</a>
                                            </div>
                                            <div class="dropdown-body">
                                                <div class="nk-notification">
                                                    <div v-for="notification in notificationList" :key="notification.id" class="nk-notification-item dropdown-inner">
                                                        <div class="nk-notification-icon">
                                                            <em v-bind:class="notification.from ? 'bg-warning-dim ni ni-curve-down-right' : 'bg-success-dim ni ni-curve-down-left'" class="icon icon-circle"></em>
                                                        </div>
                                                        <div class="nk-notification-content">
                                                            <div class="nk-notification-text">{{notification.title}}</div>
                                                            <div class="nk-notification-time">{{notification.timeAgo}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="dropdown-foot center">
                                                <a v-on:click="GoAllNotification()" href="javascript:void(0)">View All</a>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                
                <router-view></router-view>

                <div class="nk-footer">
                    <div class="container-fluid">
                        <div class="nk-footer-wrap">
                            <div class="nk-footer-copyright">
                                &copy; 2022 Black Stone Capitals.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <withdrawal-modal :userDetail="userDetail" :type="'Add'" :approval="'Processing'" :show="show" v-if="show" @close="show=false" />
    </div>
</template>


<script>

    export default {
        name: 'locale-changer',
        data() {
            return {
                langs: ['en', 'ar'],
                fullName: '',
                displayUserName: '',
                displayUserEmail: '',
                role: '',
                verified: false,
                depositAmount: 0,
                profitAmount: 0,
                sevenDayProfitAmount: 0,
                profitInPercent: 0,
                notificationList: 0,
                userDetail: '',
                urlLink: '',
                show: false,
                activeBasicPackage: false,
                render: 0,
                packagePlanAmount: 0,
                shortName: '',
                isImpersonating: false,
            }
        },
        methods: {
            openModel: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Bonus/WithdrawalNetAmountDetail', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userDetail = response.data;
                        root.show = true;
                    }
                });
            },

            GoTo: function (link) {
                this.$router.push(link);
                this.render++;
            },

            GoToUserProfileInfo: function () {
                this.$router.push('/UserProfileInfo')
            },

            GoAllNotification: function () {
                this.$router.push('/Notifications')
            },

            setLocale(locale) {
                this.$i18n.locale = locale
                localStorage.setItem('locales', locale);

            },
            logout: function () {
                var root = this;
                var url = '/account/logout';
                root.$https.post(url, this.login).then(function (response) {

                    if (response.data == "Success") {
                        root.$session.destroy();
                        localStorage.removeItem('locales');
                        root.$router.push('/')
                    }
                    else {
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Error Logging Out',

                            });
                    }

                });

            },

            GetNotificationData: function () {
                var root = this;
                var url = '/Company/NotificationList?pageNumber=1';
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.notificationList = response.data.results.notificationList;
                        root.verified = response.data.results.verified;
                        localStorage.setItem('Verified', response.data.results.verified);
                    }
                }).catch(error => {
                    console.log(error);
                });
            },

            AdminLogin: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/account/ImpersonatingUser?userId=' + localStorage.getItem('OriginalUserId'), { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {

                        localStorage.setItem('token', response.data.token);
                        localStorage.setItem('UserName', response.data.userName);
                        localStorage.setItem('UserEmail', response.data.userEmail);
                        localStorage.setItem('RoleName', response.data.roleName);
                        localStorage.setItem('UserID', response.data.userId);
                        localStorage.setItem('FullName', response.data.fullName);
                        localStorage.setItem('FirstName', response.data.firstName);
                        localStorage.setItem('LastName', response.data.lastName);
                        localStorage.setItem('Verified', response.data.verified);
                        localStorage.setItem('ReferralId', response.data.referralId);
                        localStorage.setItem('PackagePlanAmount', response.data.packagePlanAmount);
                        localStorage.setItem('ActiveBasicPackage', response.data.activeBasicPackage);
                        localStorage.setItem('IsImpersonating', false);

                        window.location.href = "/AdminDashboard";
                    }
                });

            },


            GetShortName: function (firstName, lastName) {
                var first = firstName == null || firstName == '' || firstName == undefined ? '' : firstName.substr(0, 1);
                var third = lastName == null || lastName == '' || lastName == undefined ? '' : lastName.substr(0, 1);
                this.shortName = first + third;
            },

        },
        mounted: function () {
            debugger;
            var path = window.location.origin;
            this.urlLink = path + '/SignUp?referralNo=' + localStorage.getItem('ReferralId');

            if (this.$session.exists()) {
                this.displayUserName = localStorage.getItem('UserName');
                this.displayUserEmail = localStorage.getItem('UserEmail');
                this.role = localStorage.getItem('RoleName');
                this.fullName = localStorage.getItem('FullName');

                this.GetShortName(localStorage.getItem('FirstName'), localStorage.getItem('LastName'));

                this.verified = localStorage.getItem('Verified') == 'true' ? true : false;
                this.isImpersonating = localStorage.getItem('IsImpersonating') == 'true' ? true : false;
                this.activeBasicPackage = localStorage.getItem('ActiveBasicPackage') == 'true' ? true : false;
                this.packagePlanAmount = parseFloat(localStorage.getItem('PackagePlanAmount'));

                this.GetNotificationData();
            }
            if (!this.$session.exists()) {
                this.$router.push('/');
            }
        }

    }
</script>



